import { gql } from 'graphql-request';
import { graphQLApi } from 'utils/Api';
import {
  RemoveEmployeesFromOverrideInput,
  RemoveEmployeesFromOverrideVariables,
  RemoveEmployeesFromOverrideMutationResponse,
} from '../types';

const removeEmployeesFromOverrideMutation = gql`
  mutation RemoveEmployeesFromOverride($input: RemoveEmployeesFromOverrideInput!) {
    payrollRemoveEmployeesFromOverride(input: $input) {
      code
      success
      message
      data
    }
  }
`;

export const removeEmployeesFromOverride = (
  input: RemoveEmployeesFromOverrideInput,
): Promise<RemoveEmployeesFromOverrideMutationResponse> => {
  return graphQLApi<RemoveEmployeesFromOverrideMutationResponse, RemoveEmployeesFromOverrideVariables>(
    {
      query: removeEmployeesFromOverrideMutation,
      queryVariables: {
        input,
      },
    },
  );
};

